<template>
  <div class="flex flex-wrap mb-4 md:mb-6">
    <div
      v-for="variant in product.variants"
      :key="variant.title"
      class="relative"
    >
      <product-variant
        :variant="variant"
        :product="product"
        :selected="variant.id === selectedVariantId"
        :img="images[variant.imageIds[0]]"
        class="test"
        @hoveron="$emit('hoveron', $event)"
        @hoveroff="$emit('hoveroff', $event)"
        @click-swatch="$emit('click-swatch', $event)"
      />
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('product')

export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
    selectedVariantId: { type: Number, default: 0 },
  },
  emits: ['click-swatch', 'hoveron', 'hoveroff'],
  computed: {
    ...mapState(['images']),
  },
  created() {
    console.log(this.images)
}
}
</script>
